
const RemovalsProcess = () => {
  const steps = [
    {
      number: '1',
      title: 'Contact Us',
      description: 'Reach out via WhatsApp, phone, or email with your removal details',
      icon: 'ri-phone-line',
    },
    {
      number: '2',
      title: 'Get Quote',
      description: 'Receive a transparent, no-obligation quote with no hidden fees',
      icon: 'ri-file-list-3-line',
    },
    {
      number: '3',
      title: 'Schedule Service',
      description: 'Book your preferred date and time - same-day service available',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '4',
      title: 'Job Complete',
      description: 'We transport your items safely and complete the job professionally',
      icon: 'ri-checkbox-circle-line',
    },
  ];

  return (
    <div className="mb-16">
      <h2 className="font-serif text-4xl font-bold text-charcoal mb-4">
        How Our Removal Process Works
      </h2>
      <p className="text-gray-600 text-lg mb-12 leading-relaxed">
        Simple, straightforward, and stress-free. Here's how we make your bakkie removal experience easy from start to finish.
      </p>

      <div className="bg-greenbg rounded-2xl p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 relative z-10">
                  <i className={`${step.icon} text-white text-3xl w-8 h-8 flex items-center justify-center`}></i>
                </div>
                <div className="absolute top-10 left-1/2 w-full h-0.5 bg-primary/30 -z-0 hidden lg:block" style={{ display: index === steps.length - 1 ? 'none' : 'block' }}></div>
                <div className="bg-white rounded-full w-10 h-10 flex items-center justify-center mx-auto mb-3 font-bold text-primary border-2 border-primary">
                  {step.number}
                </div>
                <h3 className="font-bold text-lg text-charcoal mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RemovalsProcess;
